import { jsx as _jsx } from "react/jsx-runtime";
import _ from 'lodash';
import { Button as SemanticButton, } from 'semantic-ui-react';
import { ColorNames } from '../../../constants/colorVars';
import classnames from 'classnames/bind';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const defaultProps = {
    role: undefined,
    color: undefined,
    size: 'medium',
    tag: 'button',
    isStretch: false,
    isSelected: false,
    collapse: false,
    link: null,
    className: null,
    children: null,
    elmId: undefined,
};
const Button = ({ role, color, size = 'medium', tag = 'button', isStretch = false, isSelected = false, collapse = false, link = null, className = null, children = null, elmId = null, ...rest }) => {
    let newRole = role || 'secondary';
    let newColor = color;
    if (!newColor) {
        newColor = ColorNames.Action;
    }
    if (newColor === 'basic')
        newColor = ColorNames.Gray;
    if (newRole === 'default')
        newRole = 'secondary';
    const baseClasses = [
        'button-root',
        `button-role-${newRole}`,
        `button-color-${_.kebabCase(newColor || ColorNames.Gray)}`,
        `button-is-${size}`,
    ];
    if (isStretch)
        baseClasses.push('button-is-stretch');
    if (isSelected)
        baseClasses.push('button-is-selected');
    const tagName = link ? 'a' : tag || 'button';
    const newClassName = cx(...baseClasses.map(cls => styles[cls]), { collapse }, className);
    return (_jsx(SemanticButton, { ...rest, className: newClassName, as: tagName, href: link || undefined, "data-elm-id": elmId || undefined, children: children }));
};
const ButtonWithStatics = Button;
ButtonWithStatics.Group = ({ wrap, ...props }) => (_jsx(SemanticButton.Group, { className: cx('button-group', { wrap }), ...props, basic: true }));
Button.defaultProps = defaultProps;
export default ButtonWithStatics;
//# sourceMappingURL=index.js.map